import React from 'react'
import { Modal } from 'antd'
import { base64Encode } from '../../../../../../utils';
const KkFileView = (props) => {
  const { visible, onCancel, file: { url = '', name = '' } } = props
  let urlHost = window.location.origin;
  let previewUrl = encodeURIComponent(base64Encode(`${urlHost}${url}?fullfilename=${name}`));
  let officeViewUrl = urlHost + '/kkfileview/onlinePreview' + "?url=" + previewUrl;
  const iframeProps = {
    style: { width: "100%", height: "100%" },
    src: officeViewUrl,
    onContextMenu: (e) => e.preventDefault()
  };

  return (
    <Modal
      visible={visible}
      title={name}
      onCancel={onCancel}
      footer={null}
      width={800}
      bodyStyle={{
        height: "78vh",
      }}
    >
      <iframe {...iframeProps} id={`iframe_${url}`} />
    </Modal>
  )
}

export default KkFileView